export default "__VITE_ASSET__Cmhx4lJt__"